module.exports = __webpack_public_path__ + "media/images/menu_sel_1-61b73f5ac8f346d5a9544670afc4a1c4.png";